import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"
import { selectionFormData, selectedMemberCount, reloadRoster } from "../utils/roster_selection"

export default class extends Controller {
  static targets = ["modal", "title", "description", "accessLevelInput", "submitButton"]
  static values = { url: String }

  open(event) {
    event.preventDefault()

    this.selectedCount = selectedMemberCount(this)
    if (this.selectedCount === 0) return

    this.resetForm()
    this.updateCopy(this.selectedCount)
    Modal.getOrCreateInstance(this.modalTarget).show()
    this.validate()
  }

  validate() {
    if (!this.hasSubmitButtonTarget) return

    const accessLevelSelected = this.accessLevelInputTargets.some((input) => input.checked)
    this.submitButtonTarget.disabled = !accessLevelSelected || this.submitButtonTarget.dataset.saving === "true"
  }

  async save(event) {
    event.preventDefault()

    const accessLevel = this.selectedAccessLevel()
    if (selectedMemberCount(this) === 0 || !accessLevel || !this.hasUrlValue) return

    this.setSaving(true)

    const formData = selectionFormData(this)
    formData.append("_method", "PATCH")
    formData.append("access_level", accessLevel)

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        body: formData,
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
          "Accept": "application/json"
        },
        credentials: "same-origin"
      })

      const data = await response.json()

      if (response.ok && data.success) {
        Modal.getOrCreateInstance(this.modalTarget).hide()
        reloadRoster(this)
      } else {
        const message = data?.errors?.join(", ") || `HTTP ${response.status}`
        alert(`Failed to update access levels: ${message}`)
      }
    } catch (error) {
      console.error("Error bulk updating access levels:", error)
      alert("An error occurred. Please try again.")
    } finally {
      this.setSaving(false)
      this.validate()
    }
  }

  modalHidden() {
    this.resetForm()
    this.validate()
  }

  resetForm() {
    this.accessLevelInputTargets.forEach((input) => {
      input.checked = false
    })
  }

  updateCopy(count) {
    const noun = count === 1 ? "member" : "members"

    if (this.hasTitleTarget) {
      this.titleTarget.textContent = `Edit access level for ${count} ${noun}`
    }

    if (this.hasDescriptionTarget) {
      this.descriptionTarget.textContent = `This will overwrite the access level for all ${count} ${noun}.`
    }

    if (this.hasSubmitButtonTarget && this.submitButtonTarget.dataset.saving !== "true") {
      this.submitButtonTarget.textContent = count === 1 ? "Update 1 member" : `Update ${count} members`
    }
  }

  selectedAccessLevel() {
    const selected = this.accessLevelInputTargets.find((input) => input.checked)
    return selected?.value
  }

  setSaving(saving) {
    if (!this.hasSubmitButtonTarget) return

    this.submitButtonTarget.dataset.saving = saving ? "true" : "false"

    if (saving) {
      this.submitButtonTarget.textContent = "Saving..."
    } else {
      this.updateCopy(this.selectedCount)
    }

    this.submitButtonTarget.disabled = saving || !this.selectedAccessLevel()
  }
}
